<template>
  <section class="truck">
    <drivers-header title="Водители" back="/more-items"/>
    <div class="driver">
      <div class="driver__title">Зарегистрированные водители</div>
      <div class="driver__content">
        <double-input-search
          title="Введите для поиска"
          class="truck__search"
          :show-search-list="showSearchDriver"
          :search-list="driverFios"
          :has-error="hasDriverError"
          :loading="loading"
          @input-changed="searchDriver"
          @input-blured="showResultDriver"
          @input-selected="selectResultDriver"
        />
        <el-table
          v-if="loading"
          v-loading="loading"
          :data="[]"
          element-loading-text="Загрузка..."
        />
        <template v-else>
          <driver-item
            v-for="driver in driversList"
            :key="driver.id"
            :driver="driver"
          />
          <div v-if="!driversList.length && !showSearchDriver" class="adding__nothing">
            <div class="adding__nothing-warning">
              {{ hasDriverError ? `По запросу “${searchValue}” ничего не найденно.` : 'Нет водителей для выбора' }}
            </div>
            <div class="adding__nothing-add">
              {{ hasDriverError ? 'Введите другого водителя или добавьте нового' : 'Добавьте водителя ' }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { GET_FILTER_DRIVERS } from '@/store/actions/drivers'
import { mapGetters } from 'vuex'
import DoubleInputSearch from '@/components/Drivers/DoubleInputSearch/DoubleInputSearch'
import DriverItem from './components/DriverItem'
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'

export default {
  name: 'DriversMobile',
  components: { DriverItem, DriversHeader, DoubleInputSearch },
  data() {
    return {
      searchValue: '',
      showSearchDriver: false,
      hasDriverError: false,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'drivers/getLoading',
      driversList: 'drivers/getDrivers',
    }),
    // списки номеров авто для отображения в выпадашке инпута поиска
    // списки ФИО водителей для отображения в выпадашке инпута поиска
    driverFios() {
      return this.driversList.map(item => item.fio)
    },
  },
  mounted() {
    this.searchDriver()
  },
  methods: {
    // обработка ввода значений в инпут поиска водителя
    searchDriver(value = '') {
      this.hasDriverError = false

      if (value.length > 2) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          fio: value,
          carrier_inn: this.cur_org_inn,
        })
        this.showSearchDriver = true
      }
      if (!value.length) {
        this.showSearchDriver = false
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          carrier_inn: this.cur_org_inn,
        })
      }
    },
    // конец ввода строки поиска водителя
    showResultDriver(value) {
      this.showSearchDriver = false
      if (!this.driversList.length) {
        this.hasDriverError = true
        this.searchValue = value
      }
    },
    // выбор ФИО водителя из выпадающего списка
    selectResultDriver(value) {
      this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
        fio: value,
        carrier_inn: this.cur_org_inn,
      })
      this.showSearchDriver = false
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.truck__search
  margin-bottom: 2rem
.adding__nothing
  display: flex
  flex-direction: column
  justify-content: center
  height: 6.4rem
  border-top: 1px solid #D7D7D7
  &-warning
    margin-bottom: 0.2rem
    font-weight: 700
    font-size: 1.4rem
    line-height: 1.8rem
    color: #ED2121
  &-add
    font-weight: 400
    font-size: 1.2rem
    line-height: 1.6rem
    color: #747474
</style>
